import { wrapLinksInText } from '@/utils/textUtils.js';

const processPostsArray = (posts) => {
  return posts.map(post => {
    if (post?.text) {
      post.text = wrapLinksInText(post.text);
    }
    if (post.repostedPost && post.repostedPost.text) {
      post.repostedPost.text = wrapLinksInText(post.repostedPost.text)
    }
    return post;
  });
};

const linkWrappingPlugin = (store) => {
  store.subscribe((mutation) => {
    if (!mutation.payload) return;

    let postsToProcess = mutation.payload.data || mutation.payload;

    if (Array.isArray(postsToProcess)) {
      processPostsArray(postsToProcess);
    }
  });
};

export default linkWrappingPlugin;
